export const account = [
  {
    title: 'Account General',
    href: '/account/?pid=general',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-general-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-general--dark-min.png',
  },
  {
    title: 'Account Security',
    href: '/account/?pid=security',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-security-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-security--dark-min.png',
  },
  {
    title: 'Account Notifications',
    href: '/account/?pid=notifications',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-notifications-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-notifications--dark-min.png',
  },
  {
    title: 'Account Billing',
    href: '/account/?pid=billing',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-billing-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/account-billing--dark-min.png',
  },
  {
    title: 'Signup Simple',
    href: '/signup-simple',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/signup-simple-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/signup-simple--dark-min.png',
  },
  {
    title: 'Signup Cover',
    href: '/signup-cover',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/signup-cover-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/signup-cover--dark-min.png',
  },
  {
    title: 'Signin Simple',
    href: '/signin-simple',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/signin-simple-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/signin-simple--dark-min.png',
  },
  {
    title: 'Signin Cover',
    href: '/signin-cover',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/signin-cover-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/signin-cover--dark-min.png',
  },
  {
    title: 'Password Reset Simple',
    href: '/password-reset-simple',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/password-reset-simple-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/password-reset-simple--dark-min.png',
  },
  {
    title: 'Password Reset Cover',
    href: '/password-reset-cover',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/password-reset-cover-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/password-reset-cover--dark-min.png',
  },
  {
    title: 'Error Simple',
    href: '/not-found',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/error-simple-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/error-simple--dark-min.png',
  },
  {
    title: 'Error Cover',
    href: '/not-found-cover',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/account/error-cover-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/account/error-cover--dark-min.png',
  },
];

export const landings = [
  {
    title: 'Coworking',
    href: '/coworking',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/coworking-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/coworking--dark-min.png',
  },
  {
    title: 'Rental',
    href: '/rental',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/rental-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/rental--dark-min.png',
  },
  {
    title: 'Job Listing',
    href: '/job-listing',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/job-listing-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/job-listing--dark-min.png',
  },
  {
    title: 'E-Learning',
    href: '/e-learning',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/e-learning-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/e-learning--dark-min.png',
  },
  {
    title: 'E-commerce',
    href: '/e-commerce',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/e-commerce-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/e-commerce--dark-min.png',
  },
  {
    title: 'Expo',
    href: '/expo',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/expo-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/expo--dark-min.png',
  },
  {
    title: 'Desktop App',
    href: '/desktop-app',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/desktop-app-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/desktop-app--dark-min.png',
  },
  {
    title: 'Mobile App',
    href: '/mobile-app',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/mobile-app-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/mobile-app--dark-min.png',
  },
  {
    title: 'Overview Page',
    href: '/home',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/overview-min.jpg',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/overview--dark-min.png',
  },
  {
    title: 'Basic',
    href: '/web-basic',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/web-basic-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/web-basic--dark-min.png',
  },
  {
    title: 'Service',
    href: '/service',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/service-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/service--dark-min.png',
  },
  {
    title: 'Startup',
    href: '/startup',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/startup-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/startup--dark-min.png',
  },
  {
    title: 'Enterprise',
    href: '/enterprise',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/enterprise-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/enterprise--dark-min.png',
  },
  {
    title: 'Cloud Hosting',
    href: '/cloud-hosting',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/cloud-hosting-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/cloud-hosting--dark-min.png',
  },
  {
    title: 'Agency',
    href: '/agency',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/agency-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/agency--dark-min.png',
  },
  {
    title: 'Design Company',
    href: '/design-company',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/design-company-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/design-company--dark-min.png',
  },
  {
    title: 'Logistics',
    href: '/logistics',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/logistics-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/logistics--dark-min.png',
  },
];

export const pages = [
  {
    title: 'Career Listing',
    href: '/career-listing',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/career-listing-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/career-listing--dark-min.png',
  },
  {
    title: 'Career Listing Minimal',
    href: '/career-listing-minimal',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/career-listing-minimal-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/career-listing-minimal--dark-min.png',
  },
  {
    title: 'Job Opening',
    href: '/career-opening',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/career-opening-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/career-opening--dark-min.png',
  },
  {
    title: 'Help Center Overview',
    href: '/help-center',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/help-center-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/help-center--dark-min.png',
  },
  {
    title: 'Help Center Article',
    href: '/help-center-article',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/help-center-article-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/help-center-article--dark-min.png',
  },
  {
    title: 'Company About',
    href: '/about',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/about-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/about--dark-min.png',
  },
  {
    title: 'Company About (Cover)',
    href: '/about-side-cover',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/about-side-cover-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/about-side-cover--dark-min.png',
  },
  {
    title: 'Company Pricing',
    href: '/pricing',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/pricing-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/pricing--dark-min.png',
  },
  {
    title: 'Company Terms',
    href: '/company-terms',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/company-terms-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/company-terms--dark-min.png',
  },
  {
    title: 'Blog Newsroom',
    href: '/blog-newsroom',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-newsroom-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-newsroom--dark-min.png',
  },
  {
    title: 'Blog Reach View',
    href: '/blog-reach-view',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-reach-view-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-reach-view--dark-min.png',
  },
  {
    title: 'Blog Search',
    href: '/blog-search',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-search-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-search--dark-min.png',
  },
  {
    title: 'Blog Article',
    href: '/blog-article',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-article-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/blog-article--dark-min.png',
  },
  {
    title: 'Portfolio Basic',
    href: '/portfolio-page',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/portfolio-page-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/portfolio-page--dark-min.png',
  },
  {
    title: 'Portfolio Masonry',
    href: '/portfolio-masonry',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/portfolio-masonry-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/portfolio-masonry--dark-min.png',
  },
  {
    title: 'Portfolio Grid View',
    href: '/portfolio-grid',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/portfolio-grid-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/portfolio-grid--dark-min.png',
  },
  {
    title: 'Portfolio Parallax Effect',
    href: '/agency',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/landings/agency-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/landings/agency--dark-min.png',
  },
  {
    title: 'Contact Reach View',
    href: '/contact-page',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/contact-page-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/contact-page--dark-min.png',
  },
  {
    title: 'Contact Sidebar Map',
    href: '/contact-sidebar-map',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/contact-sidebar-map-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/contact-sidebar-map--dark-min.png',
  },
  {
    title: 'Contact Cover',
    href: '/contact',
    cover: 'https://assets.maccarianagency.com/the-front/web-screens/pages/contact-page-cover-min.png',
    coverDark: 'https://assets.maccarianagency.com/the-front/web-screens/pages/contact-page-cover--dark-min.png',
  },
];
